import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';

export const FormWrapper = styled.div<{ backgroundColour?: string }>`
  position: relative;
  background-color: var(--colour-${(p) => p.backgroundColour ?? 'off-white'});
  padding: var(--spacer-medium);
  width: 100%;
  border-radius: var(--border-radius-tiny);
  min-height: 700px;

  border: 1px solid var(--colour-border-subtle);

  ${screen.desktop} {
    padding: var(--spacer-medium) var(--spacer-large);
  }

  fieldset {
    min-width: 100%;
  }

  .input {
    margin-right: 0 !important;
  }

  .hs-form-radio,
  .hs-form-checkbox {
    margin: var(--spacer-huge) 0;

    &:first-of-type {
      margin-top: var(--spacer-large);
    }

    &:last-of-type {
      margin-bottom: var(--spacer-small);
    }

    ${screen.desktop} {
      margin: var(--spacer-medium) 0;

      &:first-of-type {
        margin-top: var(--spacer-medium);
      }

      &:last-of-type {
        margin-bottom: var(--spacer-tiny);
      }
    }
  }

  .legal-consent-container {
    margin-top: var(--spacer-huge);
    border-top: 1px solid var(--colour-navy-tint);
    padding-top: var(--spacer-large);
    padding-left: vat(--spacer-tiny);

    ul {
      margin: 25px 0;
    }

    .hs-richtext {
      margin-left: var(--spacer-huge);
      padding-left: var(--spacer-small);
      line-height: var(--line-height-medium);

      ${screen.desktop} {
        margin-left: var(--spacer-large);
        padding-left: 0;
      }
    }

    ${screen.desktop} {
      padding-top: var(--spacer-medium);
      margin-top: var(--spacer-large);
    }

    a {
      text-decoration: underline;
      color: inherit;
    }
  }

  .hs_recaptcha {
    margin-top: var(--spacer-huge);

    ${screen.desktop} {
      margin-top: var(--spacer-medium);
    }
  }

  .hs-submit {
    display: flex;
    justify-content: flex-start;
    padding-top: var(--spacer-small);

    ${screen.desktop} {
      padding-top: 0;
    }
  }

  .hs-button {
    width: unset !important;
    background: transparent;
    border-color: var(--colour-navy);
    color: var(--colour-navy);
    border-radius: var(--border-radius-ml);
    margin-top: var(--spacer-huge);
    padding: var(--spacer-medium) var(--spacer-huge);
    line-height: var(--line-height-small);
    font-size: var(--paragraph-sm);
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    transition: all 0.2s ease;

    ${screen.desktop} {
      padding: var(--spacer-small) var(--spacer-medium);
      margin-top: var(--spacer-large);
    }

    :hover {
      background-color: var(--colour-navy);
      color: var(--colour-white);
    }
  }

  .hs-error-msg {
    margin-top: var(--spacing-100);
  }

  .hs-error-msg label {
    color: var(--colour-red);
    line-height: var(--line-height-medium);
  }

  .form-columns-2 {
    display: flex;
    flex-direction: column;

    ${screen.desktop} {
      flex-direction: column;
    }

    div {
      float: unset !important;
      width: 100% !important;
    }
  }

  .hs-form-field > ul.hs-error-msgs {
    margin-top: var(--spacer-tiny);
    position: relative;
  }

  .hs_error_rollup {
    margin-top: var(--spacer-medium);
    color: var(--colour-red);
  }

  .hs-fieldtype-select > ul.hs-error-msgs::before {
    right: 45px;
  }

  .submitted-message {
    display: none;
  }
`;
